module.exports = __webpack_public_path__ + "static/media/key.a540b527.svg";